export default "__VITE_ASSET__Bdx$pbEj__"